import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useIntl, FormattedMessage } from 'react-intl';

import Box from '@mui/material/Box';
import Alert from '@mui/material/Alert';

import TSTable from '@ts-core/components/Table/TSTable';
import CSVReader from '@ts-core/components/CSVReader';
import Button from '@ts-core/components/Button';

const ImportStudentsFromFileForm = (props) => {
  const intl = useIntl();

  const {
    students,
    submitting,
    onImportStudents,
    onFileLoaded,
    onFilterStudents,
    error,
  } = props;

  const columns = useMemo(
    () => [
      {
        Header: intl.formatMessage({ id: 'studentsTable.column.name' }),
        value: intl.formatMessage({ id: 'studentsTable.column.name' }),
        accessor: 'name',
        sortable: true,
      },
      {
        Header: intl.formatMessage({ id: 'studentsTable.column.email' }),
        value: intl.formatMessage({ id: 'studentsTable.column.email' }),
        accessor: 'email',
        sortable: true,
      },
      {
        Header: intl.formatMessage({ id: 'studentsTable.column.personalId' }),
        value: intl.formatMessage({ id: 'studentsTable.column.personalId' }),
        accessor: 'personalId',
        sortable: true,
      },
      {
        Header: intl.formatMessage({ id: 'studentsTable.column.group' }),
        value: intl.formatMessage({ id: 'studentsTable.column.group' }),
        accessor: 'group',
        id: 'group',
        sortable: true,
        filterable: true,
        filterMethod: (filter, row) => {
          if (!filter || filter.value === 'all') return true;
          return row.group && row.group === filter.value;
        },
      },
    ],
    [intl]
  );

  return (
    <Box width="100%" minWidth={600}>
      {students && !error ? (
        <Box display="flex" flexDirection="column">
          <TSTable
            loading={false}
            title=""
            data={students}
            columns={columns}
            onSearch={onFilterStudents}
          />
          <Box
            display="flex"
            flexDirection="row"
            justifyContent="flex-end"
            my={2}
          >
            <Button
              variant="contained"
              color="primary"
              loading={submitting}
              onClick={onImportStudents}
            >
              <FormattedMessage id="addStudentForm.button.add" />
            </Button>
          </Box>
        </Box>
      ) : (
        <>
          <CSVReader
            title={<FormattedMessage id="students.uploadCSV.helpTitle" />}
            subtitle={
              <a
                href="https://docs.google.com/spreadsheets/d/1oipgSpS6ymKq2FxbhDU9szMD4eTEJMMUZ3ixqFK5dSE/edit?usp=sharing"
                target="_blank"
                rel="noreferrer"
              >
                Ver archivo de ejemplo
              </a>
            }
            onFileLoaded={onFileLoaded}
          />
          {error && <Alert severity="error">{error}</Alert>}
        </>
      )}
    </Box>
  );
};

ImportStudentsFromFileForm.propTypes = {
  students: PropTypes.array,
  submitting: PropTypes.bool,
  error: PropTypes.string,

  onFilterStudents: PropTypes.func,
  onFileLoaded: PropTypes.func,
  onImportStudents: PropTypes.func,
};

ImportStudentsFromFileForm.defaultProps = {
  students: undefined,
  submitting: false,
  error: undefined,

  onImportStudents() {},
  onFileLoaded() {},
  onFilterStudents: undefined,
};

export default ImportStudentsFromFileForm;
